import { Map, Record, List } from 'immutable';

const struct = {
  id:                undefined,
  atsExternalId:     undefined,
  atsPassword:       undefined,
  primarySource:     undefined,
  applications:      new List(),
  email:             undefined,
  msisdn:            undefined,
  firstName:         undefined,
  lastName:          undefined,
  gender:            undefined,
  education:         undefined,
  schoolName:        undefined,
  graduationYear:    undefined,
  lastEmployer:      undefined,
  yearsOfExp:        undefined,
  profileAttributes: new List(),
  address:           new Map(),
  createdAt:         undefined,
  updatedAt:         undefined,
  deletedAt:         undefined,
  bearerToken:       undefined,
};

export default class CandidateRecord extends Record(struct, 'CandidateRecord') {

}
